export const PPFullColorLogoE = "https://statics.payping.ir/Payping-logo/full%20logo/english/fullcolor/SVG/payping.svg";
export const PPFullColorLogoFa =
  "https://statics.payping.ir/Payping-logo/full%20logo/persian/fullcolor/0.5x/Asset%204%400.5x.png";

export enum OrderSteps {
  NoNext = 0,
  PlanList = 1,
  CreditScore = 2,
  FillProfile = 3,
  UploadSignature = 4,
  UploadVideoAndSignature = 5,
  IssuePromissory = 6,
  SignPromissory = 7,
  PayPromissory = 8,
  ChequeSubmit = 9,
  ChequeInquiry = 10,
  SignContract = 11,
  Quote = 12,
  PrePay = 13,
  GetInstallments = 14,
  PaidOff = 15,
  Canceled = 16,
  SemiCanceled = 17,
  Unknown = 100,
}
